import { ButtonLink, theme } from '@febos-io/design';

import { useTranslation } from '../hooks';

export function Error403Page() {
  const { t } = useTranslation();
  return (
    <theme.views.NotAuthorized>
      <h1>
        {t('You don\'t have permission to this resource')}
        {' '}
        🔐
      </h1>
      <ButtonLink
        className="btn-sm-block mb-1"
        href="/"
      >
        {t('Back to home')}
      </ButtonLink>
    </theme.views.NotAuthorized>
  );
}

export default Error403Page;
